import axios from '@/libs/axios'

export class ReportService {


  


  static async getReport(params) {
    return new Promise((resolve, reject) => {
      axios.post(`reports`, params )
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async exportReport(params) {
    return new Promise((resolve, reject) => {
      axios.get(`export/report`, { params: params }).then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async getPlanOptions(params) {
    return new Promise((resolve, reject) => {
      axios.get(`userGetLinked`, { params: params })
          .then(res => {
            // console.log(res.data);
            resolve(res.data)
          
          })
          .catch(reason => reject(reason.response))
    })
  }

  static async getDevicesOptions(params) {
    return new Promise((resolve, reject) => {
      axios.get(`userGetLinked`, { params: params })
          .then(res => {
           
            resolve(res.data)
          
          })
          .catch(reason => reject(reason.response))
    })
  }

  static async getAreasOptions(params) {
    return new Promise((resolve, reject) => {
      axios.get(`userGetLinked`, { params: params })
        .then(res =>{
        
           resolve(res.data)
        }
           )
        .catch(reason => reject(reason.response))
    })
  }

  static async getCategoriesOptionsBy(params) {
    return new Promise((resolve, reject) => {
      axios.get(`form/getCategoriesOptionsBy`, { params: params })
        .then(res => {
          
          resolve(res.data)
         //console.log(res.data)
        })
        .catch(reason => reject(reason.response))
    })
  }

//////////

static async getAttributesOptions(params) {
  return new Promise((resolve, reject) => {
    axios.get(`attributes`, { params: params })
      .then(res => resolve(res.data))
      .catch(reason => reject(reason.response))
  })
}

static async getCategoriesFilterBy(params) {
  return new Promise((resolve, reject) => {
    axios.get(`filters/getFilterBy`, { params: params })
      .then(res => {
        
        resolve(res.data)
       
      })
      .catch(reason => reject(reason.response))
  })
}


static async getTypesOptionsBy(params) {
  return new Promise((resolve, reject) => {
    axios.get(`form/getTypesOptionsBy`, { params: params })
      .then(res => {
        
        resolve(res.data)
       
      })
      .catch(reason => reject(reason.response))
  })
}


static async getSelectedLinks(params) {
  return new Promise((resolve, reject) => {
    axios.get(`links`, { params: params })
      .then(res => resolve(res.data))
      .catch(reason => reject(reason.response))
  })
}


static async  getFilterOptionsBy(type) {
     
  return new Promise((resolve, reject) => {
    axios.get('filters/getFilterBy', { params: {type:type} })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
}
